const mTheHeaderNav = {
  mTheHeaderNav: {
    assets: 'Mis Cursos',
    maps: 'Mis Mapas',
    billing: 'Gestión',
    subMenu: 'Menú'
  }
}

export default mTheHeaderNav
